import { FleetEventFilter } from '../interfaces/fleet-event-filter.interface';
import { FleetEventKeys } from '../enums/fleet-event-keys.enum';

export const fleetEvents: FleetEventFilter[] = [
	{
		key: FleetEventKeys.CORE,
		label: 'Core',
		icon: 'core',
		color: '#00C5C6',
	},
	{
		key: FleetEventKeys.PLC,
		label: 'PLC',
		icon: 'plc',
		color: '#3BAFFF',
	},
];
